export default "__VITE_ASSET__CX3G6MUH__"